jQuery( document ).ready(function($) {
    let modal_links = jQuery('.open-in-modal');

    modal_links.on('click', function () {
        let lightbox_link = jQuery(this).attr('href') || jQuery(this).find('[href]').first().attr('href');

        hne_show_modal();

        jQuery.ajax({
            url: hneModal.ajaxURL,
            method: "GET",
            data: {
                action: 'hne_get_lightbox_content',
                lightbox_link: lightbox_link,
            },
            success: function (response) {
                hne_modal_content.html(response);
                jQuery('body').addClass("modal-on");
            }
        });

        return false;
    })
});

function updateVideoMaxHeight() {
  const header = document.querySelector('#header-container');
  if (!header) return;

  const headerHeight = header.offsetHeight;
  document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
}

window.addEventListener('load', updateVideoMaxHeight);
window.addEventListener('resize', updateVideoMaxHeight);

document.addEventListener('DOMContentLoaded', function () {
    function applyTextTrack() {
        const iframes = document.querySelectorAll('iframe[src*="vimeo.com"]');

        iframes.forEach(iframe => {
            let src = iframe.getAttribute('src');
            if (!src) return;

            // Skip if already has texttrack
            if (src.includes('texttrack=')) return;

            const separator = src.includes('?') ? '&' : '?';
            iframe.setAttribute('src', src + separator + 'texttrack=en');
        });
    }

    // Run once on load
    applyTextTrack();

    // Watch for dynamically added iframes (SmartSlider, lazy-load, etc.)
    const observer = new MutationObserver(applyTextTrack);
    observer.observe(document.body, { childList: true, subtree: true });
});
